import React from 'react'
import { Container, FilledButton, OutlinedButton } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import Constants from './../../../utils/constants'
import Loading from '../../Loading'

const DeleteModal = props => (
  <div className={props.modalAlertOpen ? 'ln-c-modal js-modal is-open' : 'ln-c-modal js-modal'}>
    <div className="ln-u-fill-height">
      <div
        className="ln-c-modal__body js-modal-body ln-c-modal-alert__body-30perc"
        id="modalAlert"
        tabIndex="0"
        role="dialog"
        aria-labelledby="modalAlertTitle"
      >
        <Container className="ln-u-push-left ln-u-push-right">
          { props.options.isPreAction &&
          <div>
            <h3>{props.deleteModalText}</h3>
            <h5>{props.deleteReasonText}</h5>
            <div className="ln-u-push-bottom">
              <ul className="ln-o-matrix-list">
                <li className="ln-o-matrix-list__item">
                  <div className="ln-c-form-option ln-c-form-option--full ln-c-form-option--radio">
                    <input
                      className="ln-c-form-option__input"
                      id="radio1"
                      name="radio1"
                      type="radio"
                      value
                      checked={props.options.deletionReasonTypeId === Constants.DeletionReasonTypes.UserRequest}
                      onChange={e => props.handleOptionsSelectionChange(e, Constants.DeletionReasonTypes.UserRequest)}
                    />
                    <label className="ln-c-form-option__label" htmlFor="radio1">
                      User request
                    </label>
                  </div>
                </li>
                <li className="ln-o-matrix-list__item">
                  <div className="ln-c-form-option ln-c-form-option--full ln-c-form-option--radio">
                    <input
                      className="ln-c-form-option__input"
                      id="radio2"
                      name="radio1"
                      type="radio"
                      value={false}
                      checked={props.options.deletionReasonTypeId === Constants.DeletionReasonTypes.CompanyRequest}
                      onChange={e => props.handleOptionsSelectionChange(e, Constants.DeletionReasonTypes.CompanyRequest)}
                    />
                    <label className="ln-c-form-option__label" htmlFor="radio2">
                      Company request
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div className="ln-u-push-bottom">
              <div className="ln-o-grid ln-o-grid--matrix">
                <div className="ln-o-grid__item ln-u-1/4@sm ln-u-1/2@xs ln-u-1/1">
                  <OutlinedButton
                    className="ln-c-button ln-c-button--large ln-c-button--secondary ln-c-button--full"
                    role="button"
                    onClick={props.modalAlertCancel}
                  >Cancel
                  </OutlinedButton>
                </div>
                <div className="ln-o-grid__item ln-u-1/4@sm ln-u-1/2@xs ln-u-1/1">
                  <FilledButton
                    className="ln-c-button ln-c-button--large ln-c-button--primary ln-c-button--full"
                    onClick={props.modalAlertConfirm}
                    disabled={props.options.deletionReasonTypeId === Constants.DeletionReasonTypes.None}
                  >Confirm
                  </FilledButton>
                </div>
                <div className="ln-o-grid__item ln-u-1/4@sm ln-u-1/1">
                  { props.options.inProgress &&
                    <Loading title="Deleting" />
                  }
                </div>
              </div>
            </div>
          </div>
          }
          { props.options.isPreAction === false && props.hasError === false &&
            <div>
              <div className="ln-u-push-bottom">
                <li className="ln-o-matrix-list__item" >
                  <h3>{props.doneConfirmationText}</h3>
                  <p>{props.doneInformationText}</p>
                </li>
              </div>
              <button
                className="ln-c-button ln-c-button--large ln-c-button--primary ln-u-1/4@sm ln-u-1/2@xs ln-u-1/1"
                onClick={props.modalDoneClick}
              >Done
              </button>
            </div>
          }
          { props.options.isPreAction === false && props.hasError === true &&
            <div className="ln-o-flag">
              <div className="ln-o-flag">
                <div className="ln-u-push-bottom">
                  <li className="ln-o-matrix-list__item" >
                    <h3>There was an error deleting {props.forename} {props.surname}&#39;s biometric information</h3>
                  </li>
                </div>
                <div className="ln-u-push-bottom">
                  <button
                    className="ln-c-button ln-c-button--large ln-c-button--primary ln-u-1/4@sm ln-u-1/2@xs ln-u-1/1"
                    onClick={props.modalAlertCancel}
                  >Close
                  </button>
                </div>
              </div>
            </div>
          }
        </Container>
      </div>
    </div>
  </div>
)

DeleteModal.propTypes = {
  modalAlertOpen: PropTypes.bool.isRequired,
  modalAlertConfirm: PropTypes.func.isRequired,
  modalAlertCancel: PropTypes.func.isRequired,
  modalDoneClick: PropTypes.func.isRequired,
  handleOptionsSelectionChange: PropTypes.func.isRequired,
  options: PropTypes.shape({
    deletionReasonTypeId: PropTypes.number,
    isPreAction: PropTypes.bool.isRequired,
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  forename: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
  deleteModalText: PropTypes.string.isRequired,
  deleteReasonText: PropTypes.string.isRequired,
  doneConfirmationText: PropTypes.string.isRequired,
  doneInformationText: PropTypes.string.isRequired
}

export default DeleteModal



// WEBPACK FOOTER //
// ./src/components/Contractor/DeleteModal/index.jsx